const { version } = require('../../package.json') as { version: string }

export const chatReactNativeVersion = version
